import { LoadingSpinner } from "PFComponents/loading_spinner";
import { useCustomValuesImportRows } from "PFCore/hooks/queries/admin/custom_values_imports/use_custom_values_import_rows";
import { CustomValueImport } from "PFTypes";
import React, { useState } from "react";

import { ImportDataTable } from "./import_data_table";
import { ImportDataTableCounters, ImportRowsCounters } from "./import_data_table_counters";
import { ImportDataTableHeader } from "./import_data_table_header";
import css from "./import_data_table_page.module.scss";

const PER_PAGE = 25;

type ImportDataTablePageProps = {
  importData: CustomValueImport;
};

export const ImportDataTablePage = ({ importData }: ImportDataTablePageProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCounter, setSelectedCounter] = useState<ImportRowsCounters>(ImportRowsCounters.Total);

  const { isLoading, data } = useCustomValuesImportRows(
    importData.id,
    {
      perPage: PER_PAGE,
      page: currentPage,
      filter: selectedCounter !== ImportRowsCounters.Total ? selectedCounter : undefined
    },
    { keepPreviousData: true }
  );

  const handleCounterChange = (counter: ImportRowsCounters) => {
    setCurrentPage(1);
    setSelectedCounter(counter);
  };

  return (
    <div className={css.root}>
      <ImportDataTableHeader importData={importData} />
      <div className={css.tableWrapper}>
        <ImportDataTableCounters
          meta={data?.meta}
          selectedCounter={selectedCounter}
          handleCounterChange={handleCounterChange}
        />
        {isLoading || !data ? (
          <div className={css.loading}>
            <LoadingSpinner />
          </div>
        ) : (
          <ImportDataTable rowsData={data} setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
      </div>
    </div>
  );
};
